import { useEffect, useState } from "react";

// Откладывает значение на delay мс. Нужен поиску: без него каждая буква уходила бы
// отдельным запросом к списку позиций.
export const useDebouncedValue = <T>(value: T, delay: number): T => {
    const [debounced, setDebounced] = useState<T>(value);

    useEffect(() => {
        const timer = setTimeout(() => setDebounced(value), delay);

        return () => clearTimeout(timer);
    }, [value, delay]);

    return debounced;
};
